import React from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm, IDeportation } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';
import { Box } from '@chakra-ui/react';
import { useTranslation } from "react-i18next";

function VisaPrepAdditionalHistoryStep7Info(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  const renderDeportations = () => {
    const allDeportations: React.ReactNode[] = [];
    if (props.deportations && props.deportations.length) {
      props.deportations.forEach((deportation: IDeportation, i: number) => {
        allDeportations.push(
          <SummaryGroup title={t('forms.visa:deportation', { i: i + 1 })}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.OTHER_UK_VISA_COUNTRY}-${i}`}
              value={deportation.country}
              label={t('forms.visa:country')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.DEPORTED_DATE}-${i}`}
              label={t('forms.visa:dateOfDeportation')}
              value={deportation.removalDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.DEPORTED_AIRPORT}-${i}`}
              value={deportation.airport}
              label={t('forms.visa:portOrAirport2')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.DEPORTED_REASON}-${i}`}
              value={deportation.reason}
              label={t('forms.visa:reasonOfDeportation')}
            />
          </SummaryGroup>,
        );
      });
    }
    return allDeportations;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_BEEN_DEPORTED}
        label={t('forms.visa:beenDeported')}
        fullLabel={
          'Have you been deported, removed or otherwise required to leave any country including the UK in the last 10 years?'
        }
        value={boolToYesNo(props.hasBeenDeported)}
      />
      {props.hasBeenDeported ? (
        <>
          <SummaryRow className={'visa-summary'} label={t('forms.visa:howManyTimes2')} value={props.deportations?.length} />

          <Box as="ol" pl={8} key={'border-refusals'}>
            {renderDeportations()}
          </Box>
        </>
      ) : null}
    </>
  );
}

export default VisaPrepAdditionalHistoryStep7Info;
